import { PlannedPortfoliosFacade } from './facade/planned-portfolios.facade';
import { PlannedPortfoliosEffects } from './effects/planned-portfolios.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromTempPlannedPortfolios from './reducers/temp-planned-portfolios.reducer';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('tempPlannedPortfolios', fromTempPlannedPortfolios.TempPlannedPortfoliosReducer),
    EffectsModule.forFeature([PlannedPortfoliosEffects]),
    CommonModule
  ]
})
export class TempPlannedPortfoliosStoreModule { }
